import React from 'react';
import ConvocationPageShell from '../../components/ConvocationPageShell';
import TsavRichonStatic from './TsavRichonStatic';

const TsavRichon = () => (
  <ConvocationPageShell
    strapiApiId="convocation-tsav-richon"
    defaultTitle="Tsav Richon"
    variant="tsav-richon"
    StaticFallback={TsavRichonStatic}
  />
);

export default TsavRichon;
